module.exports = __webpack_public_path__ + "static/media/ehealthpro_noti_center_slider_phone2.78a46c3e.png";